'use es6';

import { useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { InputGroup } from 'foundations-components/transitional/components/InputGroup';
import { Select } from 'foundations-components/transitional/components/Select';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { H2 } from 'foundations-components/transitional/components/H2';
import { URL_REGEX_WITHOUT_PROTOCOL_REGEX } from 'ContentEditorUI/utils/urlUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PageExpiryExternalUrlModal = ({
  closeModal,
  onCreateExternalUrl
}) => {
  const [externalUrlPath, setExternalUrlPath] = useState('');
  const [externalUrlPrefix, setExternalUrlPrefix] = useState('http://');
  const isValid = URL_REGEX_WITHOUT_PROTOCOL_REGEX.test(externalUrlPath);
  const getLangKey = key => `pageSettings.form.unpublish.modal.${key}`;
  return /*#__PURE__*/_jsxs(Modal, {
    size: "auto",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: closeModal
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getLangKey('title')
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsxs(InputGroup, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getLangKey('label')
        }),
        use: "itemLeft",
        children: [/*#__PURE__*/_jsx(FormControl, {
          error: !isValid && externalUrlPath,
          children: /*#__PURE__*/_jsx(Select, {
            onChange: e => setExternalUrlPrefix(e.target.value),
            value: externalUrlPrefix,
            options: [{
              text: 'http://',
              value: 'http://'
            }, {
              text: 'https://',
              value: 'https://'
            }]
          })
        }), /*#__PURE__*/_jsx(FormControl, {
          error: !isValid && externalUrlPath,
          validationMessage: !isValid && /*#__PURE__*/_jsx(FormattedMessage, {
            message: getLangKey('invalidUrl')
          }),
          children: /*#__PURE__*/_jsx(TextInput, {
            value: externalUrlPath,
            onChange: e => setExternalUrlPath(e.target.value),
            placeholder: I18n.text(getLangKey('placeholder'))
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Tooltip, {
        disabled: externalUrlPath.length > 0,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getLangKey('invalidUrl')
        }),
        children: /*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: () => onCreateExternalUrl(externalUrlPrefix, externalUrlPath),
          disabled: !isValid,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: getLangKey('createUrlButton')
          })
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "secondary",
        onClick: closeModal,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getLangKey('cancelText')
        })
      })]
    })]
  });
};
PageExpiryExternalUrlModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  onCreateExternalUrl: PropTypes.func.isRequired
};
export default PageExpiryExternalUrlModal;